module.exports = __webpack_public_path__ + "media/img/uploads/solutions-thumb-07-f82c137b324e6cd296c4fa63e6a2ca43.jpg";